import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Check } from 'lucide-react';
import services from 'services';
import { Patient } from 'models';
import BasicForm from 'components/forms/patients/BasicForm';
import PatientDetailsForm from 'components/forms/patients/PatientDetailsForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import './style.css';
var NewPatient = function (props) {
    var t = props.translate;
    var navigate = useNavigate();
    var _a = useState(false), isFemale = _a[0], setIsFemale = _a[1];
    var _b = useState('male'), gender = _b[0], setGender = _b[1];
    var patient = useState(function () { return new Patient(); })[0];
    var _c = useState(false), disabled = _c[0], setDisabled = _c[1];
    var form = Form.useForm()[0];
    var patientService = services.patientService, patientAreaService = services.patientAreaService;
    var _d = patientService.useCreatePatient(), createPatient = _d.mutate, errorResponse = _d.isError;
    var patientAreas = patientAreaService.usePatientAreas().data;
    var submit = function () {
        setDisabled(true);
        createPatient({
            patient: patient,
            successMessage: t('patientCreated')
        });
    };
    useEffect(function () {
        if (errorResponse)
            setDisabled(false);
    }, [errorResponse]);
    useEffect(function () {
        setIsFemale(gender === 'female');
    }, [gender]);
    var scrollToFirstElement = function () {
        form.scrollToField('firstName', { behavior: 'smooth' });
    };
    return (_jsxs("div", { className: "patient-form-page", children: [_jsxs("header", { className: "patient-form-page__header", children: [_jsxs("div", { className: "patient-form-page__title-row", children: [_jsx("button", { type: "button", className: "patient-form-page__back", onClick: function () { return navigate('/patients'); }, "aria-label": t('common:buttons.cancel'), children: _jsx(ArrowLeft, { size: 18, strokeWidth: 2 }) }), _jsxs("div", { children: [_jsx("h1", { className: "patient-form-page__title", children: t('title') }), _jsx("p", { className: "patient-form-page__subtitle", children: t('subtitle') })] })] }), _jsxs("div", { className: "patient-form-page__actions", children: [_jsx("button", { type: "button", className: "patient-form-page__btn patient-form-page__btn--ghost", onClick: function () { return navigate('/patients'); }, children: t('common:buttons.cancel') }), _jsxs("button", { type: "button", className: "patient-form-page__btn patient-form-page__btn--primary", disabled: disabled, onClick: function () { return form.submit(); }, children: [_jsx(Check, { size: 16, strokeWidth: 2 }), _jsx("span", { children: t('registerPatient') })] })] })] }), _jsx("div", { className: "patient-form-page__canvas", children: _jsxs(Form, { className: "patient-form", layout: "vertical", form: form, onFinish: submit, onFinishFailed: scrollToFirstElement, requiredMark: false, children: [_jsxs("p", { className: "patient-form-page__hint", children: [_jsx("span", { children: "*" }), " ", t('requiredHint')] }), patientAreas && (_jsx(BasicForm, { patient: patient, patientAreas: patientAreas, setGender: setGender })), _jsx(PatientDetailsForm, { patient: patient, isFemale: isFemale })] }) })] }));
};
export default localeTranslator(NewPatient, 'patientForm');
